import { addFilter } from '@wordpress/hooks';
import { select } from '@wordpress/data';
import { store as blockEditorStore } from '@wordpress/block-editor';

const allowed = [
	'popper/form-input',
	'popper/form-select',
	'popper/form-textarea',
	'popper/form-multichoices',
];

function getFieldsBlock() {
	const blocks = select( blockEditorStore ).getBlocksByName( allowed );
	return blocks;
}

export function getConstraints() {
	const constraints = {};
	const fields = getFieldsBlock();
	const blocks = select( blockEditorStore ).getBlocksByClientId( fields );

	if ( blocks ) {
		blocks.forEach( ( b ) => {
			const constraint = getFieldConstraint( b );
			const name = b.attributes.name;

			constraints[ name ] = constraint;
		} );
	}

	return constraints;
}

export function getFieldConstraint( field ) {
	let constraints = [];

	if ( field.attributes.type === 'url' ) {
		constraints.push( 'url' );
	}

	if ( field.attributes.required ) {
		constraints.push( 'required' );
	}

	if ( field.attributes.type === 'email' ) {
		constraints.push( 'email' );
	}

	if ( field.attributes.type === 'number' ) {
		constraints.push( 'numeric' );
	}

	if ( 'date' === field.attributes.type ) {
		constraints.push( 'date' );
	}

	if ( field.attributes.multiple ) {
		constraints.push( 'array' );
	}

	if ( constraints.length ) {
		constraints = constraints.join( '|' );
	}

	return constraints.length ? constraints : '';
}

addFilter( 'editor.preSavePost', 'editor', ( edits ) => {
	const postType = select( 'core/editor' ).getCurrentPostType();
	const meta = select( 'core/editor' ).getCurrentPostAttribute( 'meta' );

	if ( 'popper' === postType ) {
		const constraints = getConstraints();
		let newEdits;

		// There are already meta edits?
		if ( edits.meta ) {
			newEdits = {
				...edits,
				meta: {
					...edits.meta,
					_popper_fields: constraints,
				},
			};
		} else {
			// Add our meta if they're not there
			const newMeta = {
				...meta,
				_popper_fields: constraints,
			};
			newEdits = {
				...edits,
				meta: newMeta,
			};
		}

		return Promise.resolve( newEdits );
	}

	return Promise.resolve( edits );
} );
